export default __webpack_public_path__ + "static/timeline-board-2f4989b593ab3cb5c56297afd92c91ef.webm";